/*
 * Copyright (c) Siemens AG 2018 ALL RIGHTS RESERVED.
 *
 * Digital Lifecycle Service (DLS)
 */

import React from 'react';
import FsmTable from './FSM/FsmTable';
import { icmaEnv } from '../../../utils/common';

const FSM_TABLE = 'FsmTable';
export default class ContentComponent extends React.Component {
  /**
   * Everytime the component will be updated, the script part of the loaded
   * html page will be executed. At creation time there is only a static text
   * so the execution will only happen with real html data which will always
   * be an update of the component.
   */
  componentDidUpdate(prevProps) {
    if (prevProps.selectedUrl !== this.props.selectedUrl) {
      this.executeScript();
    }
  }

  renderCustomComponent(componentName) {
    switch (componentName) {
      case FSM_TABLE:
        return <FsmTable settings={this.props.settings}/>
      default:
        return null;
    }
  }

  /**
   * Execute script after loading third party html
   */
  executeScript() {
    if (
      this.props.content.__html &&
      document
        .getElementById('dls-ap-content')
        .getElementsByTagName('script')[0]
    ) {
      const script = document
        .getElementById('dls-ap-content')
        .getElementsByTagName('script')[0].innerHTML;

      window.eval(script);
    }
  }

  render() {
    const isDE = localStorage.getItem('icmalanguage') === 'de';
    return (
      <div>
        {this.props.showNewAppBanner && (
          <div style={{ paddingTop: '65px' }}>
            <div style={{ background: '#CFF4FC', padding: '20px 16px 20px 16px', marginBottom: '-30px', borderRadius: '8px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <i className="bi bi-info-circle-fill" style={{ marginRight: '10px', fontSize: '32px', color: 'rgb(13, 110, 253)' }}></i>
                <span style={{ fontSize: '20px', fontWeight: '500' }}>
                {isDE
                  ? 'Diese Funktion wurde in die neue Web-Anwendung verlagert. Bitte verwenden Sie die neue Anwendung, um auf die Alarmübersicht zuzugreifen.'
                  : 'This feature has been moved to the new Web App. Please use the new application to access the Alarm Overview.'}
                </span>
              </div>
              <a
                href={(() => {
                  const env = icmaEnv(this.props.settings.server);
                  const subdomain = env === 'DEV' ? 'app.icma-dev' : env === 'QA' ? 'app.icma-qa' : 'app.icma';
                  return `https://${subdomain}.siemens-energy.cloud/settings/ap/iacc-sc/ao?ppid=${this.props.ppid}`;
                })()}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'inline-block', marginLeft: '42px', marginTop: '16px', color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline', fontSize: '20px', fontWeight: '500', lineHeight: '1.2' }}
              >
                {isDE ? 'Zur neuen ICMA-App' : 'Go to New ICMA App'}
              </a>
            </div>
          </div>
        )}
        {!this.props.showNewAppBanner && this.props.menuDesc && (
          <div id="dls-ap-description" className="dls-ap-decription-top">
            {this.props.menuDesc}
          </div>
        )}
        {!this.props.showNewAppBanner &&
          (this.props.component ? (
            this.renderCustomComponent(this.props.component)
          ) : (
            <div
              id="dls-ap-content"
              className="dls-ap-padding-top"
              dangerouslySetInnerHTML={this.props.content}
            />
          ))}
      </div>
    );
  }
}
